import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import utils from "../../Utils";
import strings from "../../Utils/strings";
import "./welcomeScreen.css";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../../authConfig";
import Widgets from "../../Widgets";
import { error } from "ajv/dist/vocabularies/applicator/dependencies";
import clinicService from "../../Services/clinicService";
import toast from "react-hot-toast";
import authService from "../../Services/authService";
import config from "../../Config/Config";
import axios from "axios";

function WelcomeScreen() {
  const { t } = useTranslation();
  const nav = useNavigate();
  const { instance } = useMsal();
  const [doctorLogin, setDoctorLogin] = useState(false);
  const [isloading, setIsLoading] = useState(false);
  //   const [azureRes, setAzureRes] = useState({});

  const handleLogin = (isDoctor) => {
    setIsLoading(true);
    instance
      .loginPopup(loginRequest)
      .then((azureRes) => {
        // setAzureRes(response);
        setDoctorLogin(isDoctor);
        console.log(isDoctor);
        const body = {
          isDoctor: isDoctor,
          email: azureRes.account.username,
        };
        azurePrecheck(body, azureRes, isDoctor);
        // authService.setToken(response.accessToken);
        // authService.setAdminName(response.account.name);

        // const loginTimestamp = new Date().getTime();
        // authService.setLoginTime(loginTimestamp);

        // const clearTime = 59 * 60 * 1000;
        // authService.setClearTime(loginTimestamp + clearTime);

        // nav(strings.navigation.patientProfile);
        setIsLoading(false);
      })
      .catch((e) => {
        console.error("Login failed", e);
        setIsLoading(false);
      });
  };

  const signOutClickHandler = (instance) => {
    const accounts = instance.getAllAccounts();
    if (accounts.length > 0) {
      console.log(accounts);
      const homeAccountId = accounts[0].homeAccountId;

      const logoutRequest = {
        account: instance.getAccountByHomeId(homeAccountId),
        mainWindowRedirectUri: config.azureRedirect,
      };

      instance.logoutPopup(logoutRequest);
    }
  };

  const azurePrecheck = async (body, azureRes, isDoctor) => {
    try {
      setIsLoading(true);
      let response = await clinicService.azurePrecheck(body);
      if (response.data.accountExists) {
        console.log(azureRes.accessToken);
        authService.setIsDoctorLogin(isDoctor);
        authService.setToken(azureRes.accessToken);
        nav(strings.navigation.dashboard);
      } else if (!response.data.accountExists) {
        signOutClickHandler(instance);
        toast.error("Inavlid Credentials");
      }
    } catch {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const callApi = async () => {
    const url = "https://login.microsoftonline.com/c717746a-f099-449f-afb1-7545611404b2/oauth2/v2.0/token";

    const formData = new URLSearchParams();
    formData.append("grant_type", "refresh_token");
    formData.append(
      "refresh_token",
      "1.AVUAanQXx5nwn0SvsXVFYRQEsjhCulpfHhhKnykgz31yBme_AFxVAA.AgABAwEAAADW6jl31mB3T7ugrWTT8pFeAwDs_wUA9P8HeIxJwxcGTJLMn-3x0UjuMCa0z3chYWJNynUHdxnbi1_8GFofCr_z1YxLHBVUjTIPEgei8nivdOagdFacELMqkQQGV30ypZ8kRpVfXo7Bbg1SItRejSwfdwAeq0wsk5VijM6Jz7mFwXlohegJd1EoewglWm9_EveS6uV0zTVGX55upv1iL_ruroPErbQ9vMhgxRskjHb_yPf4eBNwjQJ2bV9ojotynRlscBmv9bcP_v1uOxK6D8CSlESNjYXc_ua_WRzL9zhN1OZVf_egqXw1yUPG0HipUpiFiiY73SKs02wps1a50Z35p_lVA4xqJQeiEtdHulRgTGhZlSjuDESB5CTzwBY9pu808R0lVBTB_2Ep034fhKe6u4P61Yl5TFb0cCUUX48fPvr-mSxSa3onlfXQm15D6pKusdHUVOPAl8fqvZNcWaiGO3KY7ZMkuXFB5PcQ-CyS-ybEc5MeQ2k2ATa0dhuPfl55MaimdEyrsMoEdG0qCM5w8fgZ8-qul6vQvH15kyxWXleNR8k6ikAyfqq7HCLDU1K-cpzeAY8mRGke1iJbqbogAdGidl6bfEzAly2_Ttv4lFbZgvpqbwlVMnUNy_y8k9A-cc8H54UDKrOA7Et_wtoHEBf89Gz7JSmdPBDLx0sFvZgO-XDmbCBAu1O1figfSpQ92Ne93GGJyDn_ogU14BiOv0VAn0NKtIeEXRNym2AVE5xKF6vH4981ceSulro2eFBeNWSRflgPGpbh6cM-mnuaYh-gZQ69GAivMIziMVswmoBnM9zQrCW2TrjdOci62PNZhxCAEe_axfx9ZKvDsRjaDNmUI-_6ehiQW0cir5zSrgKzh2BiyFo",
    );
    formData.append("scope", "api://5aba4238-1e5f-4a18-9f29-20cf7d720667/fv.service.read&write");

    try {
      const response = await axios.post(url, formData, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      });
      console.log(response.data); // Process the response data as needed
    } catch (error) {
      console.error("Error:", error);
    }
  };

  return (
    <div>
      {isloading ? <Widgets.CircularLoader /> : ""}
      <div>
        <span className="welcome-title">{t("label_start")}</span>
      </div>
      <div>
        <span className="welcome-sub-title">{t("label_sub_message")}</span>
      </div>
      <section className="role-containers mt-4">
        <div
          className="role-box"
          data-toggle="tooltip"
          title={t("label_clinic_admin")}
          onClick={() => {
            handleLogin(false);
          }}
        >
          <img className="role-icon d-flex" src={utils.images.clinicLogo} alt="clinic" />
          <div className="role-container-texts">
            <span className="role">{t("label_clinic_admin")}</span>
          </div>
        </div>
        <div
          className="role-box"
          data-toggle="tooltip"
          title={t("label_doctor")}
          onClick={() => {
            handleLogin(true);
          }}
          // onClick={callApi}
        >
          <img className="role-icon2 d-flex" src={utils.images.doctorLogo} alt="doctor" />
          <div className="role-container-texts">
            <span className="role">{t("label_doctor")}</span>
          </div>
        </div>
      </section>
    </div>
  );
}

export default WelcomeScreen;
